import { memo } from "react";
import { Icon } from "../../../components/icon/Icon";
import { SelectToggleButton } from "../../../components/SelectToggleButton/SelectToggleButton";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

export const SettingsLangChooserButton = memo((props) => {
    const {lang} = useLangContext();
    const {'aria-expanded': isOpen, onClick} = props;
    return (
        <SelectToggleButton onClick={onClick} isOpen={isOpen}>
            <Icon name={`flag-${lang.lang}`} height="24px" width="24px" className="me-3"/>
            <span>{lang.lang_full_name}</span>
        </SelectToggleButton>
    )
})